import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dispatchModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import React from 'react';
import {
  FDPrimaryActionButton, FDBox, FDStack, FDSecondaryActionButton,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { navigateToUriInNewTab } from 'Helpers/Navigation';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import PlannerInformationPicker
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableFilters/PlannerInformationPicker';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { missionControlURL } from 'Hooks/useMissionControlURL';


const TITLE_FIELD_NAME = 'householdNameDisplay';

const useStyles = makeStyles(() => ({
  metaFormFieldsFlex: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const Layout = () => {
  const classes = useStyles();
  const {
    clearModalCollection,
  } = useModalContext();

  const { displaySuccess, displayErrorMessage } = useSnackbarContext();

  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const handleSubmit = async () => {
    try {
      const resp = await onSubmit();
      if (resp) {
        clearModalCollection();
        displaySuccess('Planner transition info for household updated.');
        dispatchModalContextSubmissionSuccessful();
      }
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <FDBox padding={200}>
      <FDStack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
        <FDStack direction={'row'} alignItems={'center'} justifyContent={'space-between'} wrap>
          <MetaField attr={TITLE_FIELD_NAME} />
          <FDSecondaryActionButton
            label={'Mission Control'}
            size={'sm'}
            onClick={(e) => navigateToUriInNewTab(e, missionControlURL(resource, resource.attr('householdId')))}
          />
        </FDStack>
        <FDBox width={'100%'}>
          <FDStack direction={'row'} spacing={2} justifyContent={'space-between'}>
            <FDBox width={'600px'}>
              <MetaFormFields className={classes.metaFormFieldsFlex} resource={resource} />
            </FDBox>
            <FDBox width={'250px'}>
              <PlannerInformationPicker resource={resource} />
            </FDBox>
          </FDStack>
        </FDBox>
        <FDStack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
          <FDBox width={'400px'}>
            <MetaField attr={'newPlanner'} />
          </FDBox>
        </FDStack>
        <FDPrimaryActionButton
          alignSelf={'flex-end'}
          label={'Submit'}
          onClick={handleSubmit}
          loading={saving}
        />
      </FDStack>
    </FDBox>
  );
};

export default Layout;
